import React, { useState } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import { Content } from './Content/content';
import { IGame } from '../../../providers/Games/useGames';
import { Recommended } from './Recommended/recommended';

export interface IContent {
	game: IGame;
	description?: string;
	discount?: string;
	creatorName?: string;
	image?: string;
}

interface IFeatured {
	data: IContent[];
}

export const Featured = ({ data }: IFeatured) => {
	const [active, setActive] = useState<IContent>(data[0]);

	return (
		<Flex
			display={{ base: 'flex', hashup: 'flex' }}
			width="100%"
			maxWidth={{ hashup: '1168px', xl: '1240px' }}
			borderRadius="8px"
			position="relative"
			justifyContent="center"
			alignItems="center"
			userSelect="none"
		>
			<Box
				position="absolute"
				top="0"
				w="200vw"
				h="75%"
				display={{ base: 'block', hashup: 'none' }}
			>
				<Box
					bgGradient="linear-gradient(180deg, rgba(29, 29, 29, 1) 0%, rgba(29, 29, 29, 0.1) 50%)"
					zIndex="3"
					w="200vw"
					h="100%"
					position="absolute"
				></Box>
				<Box
					bgGradient="linear-gradient(180deg, rgba(29, 29, 29, 0.1) 50%, rgba(29, 29, 29, 1) 100%)"
					zIndex="3"
					w="200vw"
					h="100%"
					position="absolute"
				></Box>
				<Box
					bgImage={`url(${active.game.media.coverImageUrl})`}
					filter="blur(2px)"
					opacity=".5"
					zIndex="0"
					w="200vw"
					h="100%"
				/>
			</Box>
			{/** 16:9 filler */}
			<Box
				width="100%"
				paddingBottom="56.25%"
				display={{ base: 'none', hashup: 'block' }}
				borderRadius="8px"
			/>
			<Image
				src={active.game.media.coverImageUrl}
				position="absolute"
				top="0"
				left="0"
				width="100%"
				height="100%"
				zIndex="1"
				borderRadius="8px"
				display={{ base: 'none', hashup: 'block' }}
			/>
			<Image
				src={active.game.media.coverImageUrl}
				position="absolute"
				top="0"
				left="0"
				zIndex="0"
				width="100%"
				height="100%"
				borderRadius="8px"
				filter="drop-shadow(16px 16px 20px) blur(100px)"
				display={{ base: 'none', hashup: 'block' }}
			/>
			<Flex
				position={{ base: 'unset', hashup: 'absolute' }}
				top="0"
				left="0"
				width="100%"
				bgColor="black"
				borderRadius="8px"
				height="100%"
				flexDirection={{ base: 'column', hashup: 'row' }}
				justifyContent="space-between"
				background={{
					base: 'none',
					hashup: 'linear-gradient(0deg, rgba(5, 5, 5, 0.8) 46.89%, rgba(29, 29, 29, 0) 69.42%)',
				}}
				alignItems={{ base: 'flex-start', hashup: 'flex-end' }}
				padding={{ base: '0 10%', hashup: '74px 60px' }}
				zIndex="6"
			>
				<Box
					bgImage={`url(${active.game.media.coverImageUrl})`}
					mb="30px"
					borderRadius="4px"
					display={{ base: 'block', hashup: 'none' }}
					h="45vw"
					w="80vw"
					zIndex="5"
					position="relative"
					bgSize="cover"
				></Box>
				<Box
					bgImage={`url(${active.game.media.coverImageUrl})`}
					borderRadius="4px"
					display={{ base: 'block', hashup: 'none' }}
					h="45vw"
					w="80vw"
					bgSize="cover"
					zIndex="3"
					opacity="0.7"
					position="absolute"
					filter="drop-shadow(-15px -5px 20px) blur(15px)"
				></Box>
				<Content data={active} />
				<Recommended
					data={data}
					setActive={setActive}
					active={active}
				/>
			</Flex>
		</Flex>
	);
};
